import { useNodeDetails } from '../../../hooks/useNodeDetails';
import styles from './NodeActivityStatus.module.css';
import { useTheme } from '../../../hooks/useTheme';

function NodeActivitySummary({ workflowUuid }: { workflowUuid: string }) {
  const { theme } = useTheme();
  const query = useNodeDetails(workflowUuid);

  const nodes = query.data ?? [];
  const { upgrade_success, upgrade_failed, upgrade_skipped, rollback_success, rollback_failed } = nodes.reduce(
    (acc, n) => {
      const s = n.status;
      if (s in acc) acc[s as keyof typeof acc]++;
      return acc;
    },
    { upgrade_success: 0, upgrade_failed: 0, upgrade_skipped: 0, rollback_success: 0, rollback_failed: 0 }
  );

  if (nodes.length === 0 && !query.error) return null;

  return (
    <div className={theme ? styles.sectionLight : styles.sectionDark}>
      <div className={styles.summaryRow}>
        <div className={styles.kpi}>
          <div className={styles.kpiLabel}>Upgrade</div>
          <div className={styles.kpiValue}>
            {nodes.length} <span className={styles.kpiUnit}>Nodes</span>
          </div>
          <div className={styles.kpiLabel}>Total</div>
        </div>
        <div className={styles.kpi}>
          <div className={styles.kpiLabel}>Upgrade</div>
          <div className={styles.kpiValue}>
            {upgrade_success} <span className={styles.kpiUnit}>Nodes</span>
          </div>
          <div className={styles.kpiDot}>
            <span className={styles.dotGreen} /> Successful
          </div>
        </div>
        <div className={styles.kpi}>
          <div className={styles.kpiLabel}>Upgrade</div>
          <div className={styles.kpiValue}>
            {upgrade_failed} <span className={styles.kpiUnit}>Nodes</span>
          </div>
          <div className={styles.kpiDot}>
            <span className={styles.dotRed} /> Failed
          </div>
        </div>
        <div className={styles.kpi}>
          <div className={styles.kpiLabel}>Upgrade</div>
          <div className={styles.kpiValue}>
            {upgrade_skipped} <span className={styles.kpiUnit}>Nodes</span>
          </div>
          <div className={styles.kpiDot}>
            <span className={styles.dotYellow} /> Skipped
          </div>
        </div>
        <div className={styles.kpi}>
          <div className={styles.kpiLabel}>Rollback</div>
          <div className={styles.kpiValue}>{rollback_success}</div>
          <div className={styles.kpiDot}>
            <span className={styles.dotGreen} /> Successful
          </div>
        </div>
        <div className={styles.kpi}>
          <div className={styles.kpiLabel}>Rollback</div>
          <div className={styles.kpiValue}>{rollback_failed}</div>
          <div className={styles.kpiDot}>
            <span className={styles.dotRed} /> Failed
          </div>
        </div>
      </div>
    </div>
  );
}

export default NodeActivitySummary;
